<template>
<div>
  <el-table :data="specificationsList" style="width: 100%" @cell-click="getProdutDetails">
    <el-table-column label="产品图片" align="center">
      <template slot-scope="scope">
        <img :src="scope.row.imgUrl" alt="" />
      </template>
    </el-table-column>
    <el-table-column prop="productName" label="产品名称" align="center" width="160"></el-table-column>
    <el-table-column prop="name" label="型号" align="center" width="160"></el-table-column>
    <el-table-column prop="company" label="厂家" align="center"></el-table-column>
    <el-table-column label="参数" align="center" width="300">
      <template slot-scope="scope" v-if="scope.row.paramsMap">
          <span v-for="(item,index) in scope.row.paramsMap" :key="index" class="params_span">{{ item.name }}: {{ item.value }}{{ item.unit }}
              <br v-if="(index+1)%2==0"/>
          </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="czbox">
          <el-button type="primary" @click.stop="getOrderPage('at',scope.row)">经销商下单</el-button>
          <el-button class="czbox_last" type="text" @click.stop="getOrderPage('join',scope.row)">加入订货单</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
  <inquiry ref="inquireRef"></inquiry>
</div>
</template>

<script>
// 询价
import { mixins } from "../mixin/index.js";
import inquiry from "./inquiry";
import {addProductCart} from "../../../utils/product";
export default {
  props: {
    specificationsList: Array,
  },
  mixins: [mixins],
  components: {
    inquiry,
  },
  data() {
    return {};
  },
  methods: {
    // 跳
    getPage(routerName, uuid, typeCode) {
      let routeData = this.$router.resolve({
        name: routerName,
        query: {
          uuid: uuid,
          typeCode: typeCode,
        },
      });
      window.open(routeData.href);
    },
    getProdutDetails(row) {
      this.getPage('productDetails', row.uuid, 'spec')
    },
    getOrderPage(type, row) {
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！");
        this.$router.push({
          name: "login",
        });
        return false;
      }else if (this.$store.state.isUsermessage.identity === 'PERSONAL' || this.$store.state.isUsermessage.identity === 'ANONYMOUS') {
        this.$confirm('请先进行企业资质认证!', '提示', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.sessionStorage.setItem("userServeId", "11");
          let routeData = this.$router.resolve({
            name: "userCenter",
            params: {
              userServeId: '11',
            },
          });
          window.open(routeData.href, "_target");
        });
        return false;
      } else if (row.enterpriseId === this.$store.state.isUsermessage.enterpriseUuid){
        this.$message.error("不能添加自己企业的产品");
        return false;
      }else {
        if(type == 'at') {
          // 数据完成之后跳转页面
          window.sessionStorage.removeItem("updateForm");
          let updateForm = [{
            imgUrl:row.imgUrl,
            productUuid:row.productUuid,
            productName:row.productName,
            productSpecUuid: row.uuid,
            specName: row.name,
            unit:row.unit
          }];
          window.sessionStorage.setItem("updateForm",JSON.stringify(updateForm));
          this.getPage("productOrderPage")
        } else {
          this.addOrderCar(row);
        }
      }
    },
    addOrderCar(item){
      addProductCart({specUuid:item.uuid,num:1}).then((res)=>{
        if (res.success) {
          this.$message.success("添加成功");
          this.$emit("countNum");
        }else{
          this.$message.error(res.message);
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
/deep/.el-table--fit {
  border: none !important;
}
/deep/.el-table th.el-table__cell {
  background-color: #f9f9f9;
  border: none !important;
}
/deep/.el-table__row {
  cursor: pointer;
}
/deep/thead {
  font-weight: bold !important;
  color: #323232 !important;
}
/deep/.el-table__empty-block {
  display: none;
}
img {
  width: 140px;
  height: 96px;
}
.params_span {
  width: 46%;
  display: inline-block;
  line-height: 45px;
  background: #eeeeee82;
  margin-bottom: 10px;
  margin-right: 10px;
  &:nth-last-child(1) {
    margin-bottom: 0;
  }
  &:nth-last-child(2) {
    margin-bottom: 0;
  }
}
.csbox {
  display: flex;
  flex-wrap: wrap;
  p {
    width: 50%;
  }
}
.czbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  .czbox_last {
    border: none;
    color: #099;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/components/productComNew.vue